import styled from 'styled-components';

const SectionTitle = styled.div`
  color: ${props => props.theme.sectionTitle};
  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;
`;

export default SectionTitle;
